import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RealityCheckSection = () => {
  const realityChecks = [
    {
      id: 1,
      icon: "AlertCircle",
      title: "Tu Energía se Desvanece",
      description: `Cada mañana es una lucha. Te levantas más cansada de lo que te acostaste.\nTu cuerpo ya no responde como antes y cada día se siente más pesado.`,
      severity: "high"
    },
    {
      id: 2,
      icon: "Scale",
      title: "El Peso No Para de Subir",
      description: `Comes igual que siempre, pero los kilos se acumulan sin piedad.\nTu ropa ya no te queda y evitas mirarte al espejo.`,
      severity: "critical"
    },
    {
      id: 3,
      icon: "Clock",
      title: "El Tiempo se Agota",
      description: `Cada año que pasa sin actuar, tu cuerpo envejece más rápido.\nLa ventana de oportunidad para revertir el daño se cierra.`,
      severity: "urgent"
    }
  ];

  const getSeverityStyles = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-destructive text-destructive-foreground';
      case 'urgent':
        return 'bg-accent text-accent-foreground';
      default:
        return 'bg-primary text-primary-foreground';
    }
  };

  return (
    <section className="py-12 sm:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            La Cruda Realidad que{' '}
            <span className="text-destructive font-heading-bold">Nadie te Dice</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Mientras sigues posponiendo el cuidado de tu salud, tu cuerpo está 
            enviando señales de alarma que ya no puedes ignorar.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {realityChecks?.map((check, index) => (
            <div
              key={check?.id}
              className="relative group"
            >
              <div className="bg-card rounded-2xl shadow-card-shadow border border-border p-8 h-full transition-smooth hover:shadow-card-elevated hover:-translate-y-1">
                {/* Severity Badge */}
                <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-body-semibold mb-6 ${getSeverityStyles(check?.severity)}`}>
                  <Icon name="AlertTriangle" size={12} className="mr-1" />
                  {check?.severity === 'critical' ? 'CRÍTICO' : check?.severity === 'urgent' ? 'URGENTE' : 'ALERTA'}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary/80 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-smooth">
                  <Icon name={check?.icon} size={32} className="text-primary-foreground" />
                </div>

                {/* Content */}
                <h3 className="font-heading text-xl md:text-2xl text-foreground mb-4">
                  {check?.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed whitespace-pre-line">
                  {check?.description}
                </p>

                {/* Progress Indicator */}
                <div className="mt-6 pt-4 border-t border-border">
                  <div className="flex items-center justify-between text-sm">
                    <span className="font-caption text-muted-foreground">
                      Nivel de Urgencia
                    </span>
                    <span className="font-body-semibold text-accent">
                      {check?.severity === 'critical' ? '95%' : check?.severity === 'urgent' ? '88%' : '76%'}
                    </span>
                  </div>
                  <div className="w-full bg-muted rounded-full h-2 mt-2">
                    <div
                      className={`h-full rounded-full transition-all duration-1000 ${
                        check?.severity === 'critical' ?'bg-destructive w-[95%]' 
                          : check?.severity === 'urgent' ?'bg-accent w-[88%]' :'bg-primary w-[76%]'
                      }`}
                    />
                  </div>
                </div>
              </div>

              {/* Step Number */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-accent rounded-full flex items-center justify-center shadow-card-shadow">
                <span className="font-mono text-sm font-medium text-accent-foreground">
                  {index + 1}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-card rounded-2xl shadow-card-shadow border border-border p-8 max-w-2xl mx-auto">
            <h3 className="font-heading text-2xl text-foreground mb-4">
              ¿Te Reconoces en Estas Situaciones?
            </h3>
            <p className="text-muted-foreground mb-6">
              Si has asentido con la cabeza aunque sea una vez, necesitas conocer tu edad real YA.
            </p>
            <div className="flex items-center justify-center space-x-2 text-accent mb-6">
              <Icon name="ArrowDown" size={20} className="animate-bounce" />
              <span className="font-body-semibold">Descúbrelo en 5 minutos</span>
              <Icon name="ArrowDown" size={20} className="animate-bounce" />
            </div>
            <Link to="/edad-real-assessment-quiz">
              <Button
                variant="default"
                size="lg"
                className="bg-accent hover:bg-accent/90 text-accent-foreground"
                iconName="ClipboardList"
                iconPosition="left"
              >
                Descubre tu Edad Real AHORA
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealityCheckSection;